import { Injectable } from '@angular/core';
import { Actions, Effect,ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { of, Observable } from 'rxjs';
import { tap, switchMap, map, catchError } from 'rxjs/operators';


import * as UsersSceneActions from '../../../actions';
import { EscenariosService } from 'src/app/services/SicarMap/Escenarios.service';


@Injectable()
export class UsersSceneEffects {

  constructor(
    private actions$: Actions,
    private sceneService: EscenariosService
  ) {}

  // effects go here
    @Effect()
    UserSceneGet$: Observable<any> = this.actions$.pipe(
        ofType(UsersSceneActions.UserSceneATypes.SCENE_USER_GET),
        switchMap((action: UsersSceneActions.UserSceneGet) => {
            return  this.sceneService.getUsuarios(action.IdUsuario)
                .pipe(
                    map((Users: any) => {
                        return new UsersSceneActions.UserSceneSuccess(Users);
                    }),
                    catchError(error => of (new UsersSceneActions.UserSceneFailure({ error })))
                );
            }
        )
    );
}
